module.exports = __webpack_public_path__ + "img/home_banner_slide_02.90d449e1.jpg";